import './wiz-select.scss';
import React from 'react';

export default function WizSelect({ options, value, onChange, className = '', required = false, ...props }) {
  return (
    <div className="wiz-select-wrapper">
      <select
        className={`wiz-select ${className}`}
        value={value}
        onChange={onChange}
        required={required}
        {...props}
      >
        {options.map((option, index) => (
          <option key={index} value={option}>
            {option}
          </option>
        ))}
      </select>
      <div className="wiz-select-arrow">
        <svg width="14" height="8" viewBox="0 0 14 8" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M1 1L7 7L13 1" stroke="#1e50e7" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
      </div>
    </div>
  );
}
